import React from 'react'
import { Input, Select, Row, Col, Form } from 'antd'

const TimePeriod = ({ disabled = false }: { disabled?: boolean }) => {
  return (
    <>
      <Input.Group>
        <Row gutter={8}>
          <Col span={2}>
            <Form.Item name='time_period_amount'>
              <Input type='number' required min={1} disabled={disabled} />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item name='time_period_unit'>
              <Select disabled={disabled}>
                <Select.Option value='day'>Day(s)</Select.Option>
                <Select.Option value='week'>Week(s)</Select.Option>
                <Select.Option value='month'>Month(s)</Select.Option>
                <Select.Option value='year'>Year(s)</Select.Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Input.Group>
    </>
  )
}

export default TimePeriod
